function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 0C13.4314 0 0 13.4314 0 30C0 46.5686 13.4314 60 30 60C46.5686 60 60 46.5686 60 30C60 13.4314 46.5686 0 30 0ZM30 56.129C15.6455 56.129 3.87097 44.5095 3.87097 30C3.87097 15.6456 15.4905 3.87097 30 3.87097C44.3545 3.87097 56.129 15.4905 56.129 30C56.129 44.3544 44.5095 56.129 30 56.129ZM47.1327 22.8676L25.3004 44.5247C24.7312 45.0893 23.8121 45.0856 23.2476 44.5165L12.8591 34.0441C12.2946 33.4749 12.2982 32.5558 12.8673 31.9912L13.898 30.969C14.4671 30.4044 15.3862 30.408 15.9508 30.9772L24.2947 39.3884L44.0658 19.7759C44.6349 19.2114 45.554 19.215 46.1186 19.7842L47.1409 20.8148C47.7056 21.384 47.7018 22.3031 47.1327 22.8676Z",
  fill: "white"
});

function SvgCheckOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check_outline.a8f12e0d.svg";
export { ForwardRef as ReactComponent };